module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mv4-l mv2"
  }), _vm._v(" "), (_vm.error) ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mr3-ns w-50 flex-grow flex-basis-2 mb4 mt4"
  }, [_c('div', {
    staticStyle: {
      "flex": "100%"
    }
  }, [_c('div', [_c('fieldset', {
    staticClass: "input-reset bn"
  }, [_c('legend', {
    staticClass: "f6 b db mb2"
  }, [_vm._v(_vm._s(_vm.$t('planssettings.addakko.choose')))]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-around"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planType),
      expression: "planType"
    }],
    staticClass: "dn",
    attrs: {
      "id": "planType1",
      "type": "radio",
      "name": "planType"
    },
    domProps: {
      "value": 'adult',
      "checked": _vm._q(_vm.planType, 'adult')
    },
    on: {
      "change": function($event) {
        _vm.planType = 'adult'
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc b ba br1 br--left b--silver silver bg-white pointer",
    attrs: {
      "tabindex": "0",
      "for": "planType1"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.planType = 'adult'
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('planssettings.addakko.adult')) + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planType),
      expression: "planType"
    }],
    staticClass: "dn",
    attrs: {
      "id": "planType2",
      "type": "radio",
      "name": "planType"
    },
    domProps: {
      "value": 'student',
      "checked": _vm._q(_vm.planType, 'student')
    },
    on: {
      "change": function($event) {
        _vm.planType = 'student'
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc b ba bl-0 br1 br--right b--silver silver bg-white pointer",
    attrs: {
      "tabindex": "0",
      "for": "planType2"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.planType = 'student'
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('planssettings.addakko.student')) + "\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt3",
    staticStyle: {
      "flex": "100%"
    }
  }, [_c('fieldset', {
    staticClass: "input-reset bn"
  }, [_c('label', {
    staticClass: "f6 b db mb2"
  }, [_vm._v(_vm._s(_vm.$t('planssettings.phoneonly.usersphone')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "phoneNumber",
      "type": "text"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }, _vm.acceptNumber],
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": _vm.phoneOnBlur
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorList.length === 0 && this.phoneNumber !== '' && !_vm.validPhoneNumber),
      expression: "errorList.length === 0 && this.phoneNumber !== '' && !validPhoneNumber"
    }],
    staticClass: "red f7"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('planssettings.addakko.entervalid')) + "\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorList.length > 0),
      expression: "errorList.length > 0"
    }]
  }, _vm._l((_vm.errorList), function(e, index) {
    return _c('span', {
      key: index,
      staticClass: "red f7"
    }, [_vm._v(_vm._s(e.message || e))])
  }), 0)])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "input-reset bn"
  }, [_c('div', {
    staticClass: "black lh-copy"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('planssettings.addakko.selected')) + " " + _vm._s(_vm.selectedCoverage.make && _vm.selectedCoverage.model ? _vm.selectedCoverage.make + ' ' + _vm.selectedCoverage.model + ' - ' : '') + "\n        " + _vm._s(_vm.selectedCoverage.name))]), _vm._v(" "), _c('div', {
    staticClass: "black lh-copy mt3"
  }, [_vm._v("Total: $" + _vm._s(_vm.selectedCoverage.price) + " (" + _vm._s(_vm.selectedCountryCurrency.currency_code) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('div', {
    staticClass: "dib-ns w-25"
  }, [_c('ak-button', {
    attrs: {
      "primary": "",
      "block": "",
      "disabled": !_vm.formComplete
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showAddPlanConfirmationModal.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('planssettings.addnewplan')))])], 1)]), _vm._v(" "), (_vm.showConfirmationModal) ? _c('ak-modal', {
    attrs: {
      "title": "Confirm adding new plan"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', [_vm._v("\n          " + _vm._s(_vm.$t('planssettings.phoneonly.adding')) + "\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-between pl4 h3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('planssettings.phoneonly.plan')) + " " + _vm._s(_vm.selectedCoverage.name)), _c('br')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('planssettings.phoneonly.number')) + " " + _vm._s(this.phoneNumber)), _c('br')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('planssettings.phoneonly.charge')) + " $" + _vm._s(_vm.coveragePriceWithDiscount) + " " + _vm._s(_vm.$t('planssettings.phoneonly.more')) + " " + _vm._s(_vm.selectedCoverage.plan_interval === 'annual' ? 'billed annually' : 'per month')), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-wrap justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('planssettings.phoneonly.nothanks')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "primary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addAkkoPlan.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('planssettings.phoneonly.confirm')))])], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height flex items-center justify-between mb3"
  }, [_c('span', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v("Add AKKO Plan")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26725ae5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/add-plan/AddAkkoPlan.vue
// module id = 1562
// module chunks = 0